<template>
  <div class="TopNewsNormal">
    <ul>
      <li v-for="(item, i) in item_list" :key="i">
        <a :href="`${urlWhatsNewDetail}?id=${item.pk}`">
          <dl>
            <dd>
              <span class="TopNewsNormal__date">
                {{ formatDate(item.start_showing) }}
              </span>
              <span v-if="item.author_name" class="c-label c-label--common">
                {{ item.author_name }}
              </span>
            </dd>
            <dt>{{ item.title }}</dt>
          </dl>
        </a>
      </li>
    </ul>
  </div>
</template>
<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import moment from "moment";
import CONST_DATA from "@/general/mixins/const/constData";

@Options({
  props: {
    item_list: { type: Array }
  }
})
export default class TopNewsNormal extends Vue {
  item_list!: any;

  get urlWhatsNewDetail() {
    return CONST_DATA.SITE_MAP.WHATS_NEW_DETAILS;
  }

  formatDate(date: string) {
    return moment(new Date(date)).format("YYYY年MM月DD日");
  }
}
</script>

<style lang="scss" scoped>
.TopNewsNormal {
  ul {
  }
  li {
    margin-bottom: 1rem;
    &:last-child {
      margin-bottom: 0;
    }
  }
  a {
    color: #1f2021;
    font-size: 1rem;
    &:hover {
      text-decoration: none;
      dt {
        color: #da291c;
      }
    }
  }
  dl {
    dd {
      .TopNewsNormal__date {
        color: #a8aaad;
        font-size: 1rem;
        padding-right: 1rem;
      }
      .c-label {
        &--common {
          background-color: #edeef0 !important;
        }
      }
    }
    dt {
    }
  }
}
</style>
